class ChooseBetFullModalController {

    constructor() {

        this.template = Handlebars.compile($("#chooseBetFullModal").html());
        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());

        var that = this;

        $(document).on("click", '.choose-bet-link', function() {

            baseController.closeSimpleMenu(); // Cerramos elección de apuesta
            baseController.closeSimpleMenu(); // Cerramos seleccion de categorías
            baseController.closeSimpleMenu(); // Cerramos seleccion de oponente

            var betStars = $(this).attr('data-stars');
            worldHomeController.setChallengeRequest(null,null,null,betStars);
            worldHomeController.createChallenge(null,'CREATE-CHALLENGE',null,true);
        });

    }
    
    draw() {
        let context = {game_bets: world.game_bets };
        context.game_bets = _.forEach(context.game_bets, function (game_bet) {
            game_bet.game_bet.points = game_bet.game_bet.points.toLocaleString('es-ES');
        });

        context.game_bets = _.sortBy(context.game_bets, [function (game_bet) {return game_bet.game_bet.order}], ['DES']);

        context['starIcon'] = customIcons["BET_ICON"];
        baseController.resetStackableOrder();
        baseController.stackSimpleMenu({title: 'TR_ELIGE_TU_APUESTA', icon: 'back'}, this.menuTemplate);
        baseController.stackSimpleContent(this.template, context, 'GAME');

    }

}
